import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { TransactionAmount } from "../TransactionAmount";
import styles from "./AmountCell.module.scss";

export const AmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, any>) => (
        <ViewTableCell>
            <TransactionAmount
                transaction={row.original}
                addSign
                color
                className={styles.amount}
            />
        </ViewTableCell>
    ),
);
AmountCell.displayName = "AmountCell";
